import MuiTypography from "@mui/material/Typography";

export const Typography = (props: any) => {
  return <MuiTypography {...props} />;
};
